import Button from './Button';
import ButtonGroup from './ButtonGroup';

Button.Group = ButtonGroup;

export default Button;


//////////////////
// WEBPACK FOOTER
// ./~/element-react/dist/npm/es6/src/button/index.js
// module id = 72
// module chunks = 0